var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class LegacyPlatformRequestGateway {
    constructor(player, requestService, responsiveService, gateway) {
        this.player = player;
        this.requestService = requestService;
        this.responsiveService = responsiveService;
        this.gateway = gateway;
    }
    jwtTokenLoginLegacy(token) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield this.responsiveService.login(token);
                this.gateway.setToken(token);
                this.player.continueLogin(result);
            }
            catch (error) {
                console.warn(error);
                if (error.message.includes("restrictedLegalText")) {
                    this.player.proceedToSecondStep({
                        jwtToken: token,
                        secondStepToken: error.message.split(":")[1]
                    });
                }
                else {
                    yield this.gateway.forceLoadAnonymousToken();
                    this.player.processLoginError(error);
                }
            }
        });
    }
    loginSecondStep(request) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield this.responsiveService.loginSecondStep(request.secondStepToken);
                if (request.jwtToken) {
                    this.gateway.setToken(request.jwtToken);
                }
                this.player.continueLogin(result);
            }
            catch (error) {
                console.warn(error);
                yield this.gateway.forceLoadAnonymousToken();
                this.player.processLoginError(error);
            }
        });
    }
    oneTimeTokenLogin(oneTimeToken, userId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const token = yield this.gateway.getToken();
                const loggedInToken = yield this.requestService.oneTimeTokenLogin(token, oneTimeToken, userId);
                yield this.jwtTokenLoginLegacy(loggedInToken);
            }
            catch (e) {
                console.warn(e);
                this.player.oneTimeTokenLoginFailed(e.message);
            }
        });
    }
}
//# sourceMappingURL=LegacyPlatformRequestGateway.js.map